<template>
  <v-card
    outlined
    class="mb-5"
    min-height="250"
  >
    <v-card-text>
      <v-row no-gutters>
        <NameField
          :item="item"
          md="2"
          />

        <StatisticField
          :item="item"
          md="2"
          />

        <ChartField
          :item="item"
          md="6"
          />

      </v-row>

    </v-card-text>

  </v-card>
</template>

<script>
import NameField from '@/modules/display/views/elevator/workload-statistic/NameField';
import ChartField from '@/modules/display/views/elevator/workload-statistic/ChartField';
import StatisticField from "@/modules/display/views/elevator/workload-statistic/StatisticField";

export default {
  name: "StatisticItem",
  components: {
    StatisticField,
    NameField,
    ChartField
  },
  props: {
    item: Object
  },
  data() {
    return {

    }
  }
}
</script>